import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { inAvviso, testoScadenza } from "../lib/abbonamento";

// All'accesso al gestionale: avviso (una volta per sessione) se l'abbonamento è vicino alla scadenza.
export const AbbonamentoNotifier = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [giorni, setGiorni] = useState(null);
  const on = !!user && ["titolare", "operatore"].includes(user.role);
  const key = `pgp_abb_notice_${user?.id || user?.email || ""}`;

  useEffect(() => {
    if (!on || sessionStorage.getItem(key)) return;
    api.get("/studio/abbonamento").then(({ data }) => {
      const g = inAvviso(data);
      if (g != null) setGiorni(g);
    }).catch(() => {});
  }, [on, key]);

  if (giorni == null) return null;
  const close = () => { sessionStorage.setItem(key, "1"); setGiorni(null); };
  const open = () => { close(); navigate("/app/impostazioni#sez-abbonamento"); };
  const red = giorni < 0;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4" data-testid="abbonamento-popup">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl pgp-fade-up">
        <div className="flex items-start gap-3">
          <div className={`h-10 w-10 shrink-0 rounded-full flex items-center justify-center ${red ? "bg-red-50" : "bg-orange-50"}`}>
            <CalendarClock className={`h-5 w-5 ${red ? "text-red-600" : "text-orange-600"}`} />
          </div>
          <div>
            <p className="text-base font-semibold text-[#111827]" data-testid="abbonamento-popup-text">{testoScadenza(giorni)}</p>
            <p className="text-sm text-[#6b7280] mt-1">Puoi richiedere il rinnovo dalla scheda Abbonamento delle impostazioni.</p>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={close} data-testid="abbonamento-popup-close"
            className="rounded-lg border border-[#d1d5db] px-4 py-2 text-sm font-medium text-[#111827] hover:bg-[#F3F4F6] transition-colors">Chiudi</button>
          <button type="button" onClick={open} data-testid="abbonamento-popup-open"
            className="rounded-lg bg-[#1d4ed8] px-4 py-2 text-sm font-semibold text-white hover:bg-[#1e40af] transition-colors">Vai all'abbonamento</button>
        </div>
      </div>
    </div>
  );
};
